import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

export const ProviderModal = ({ showProviderModal, setIsProviderModal }) => {
  const { t } = useTranslation();

  return (
    <Modal show={showProviderModal} onHide={(e) => setIsProviderModal(false)}>
      <Modal.Body>
        <div className="promocode_content login_first">
          <Link to="" onClick={(e) => setIsProviderModal(false)}>
            +
          </Link>
          <h2>{t("complete-profile-candidate")}</h2>
          <img src={window.location.origin + "/images/CompleteProfileProviders.png"} />
          <p>{t("answer-question-help")}</p>
          <button>
            <Link to={"/complete-provider-profile"}>
              {t("text-complete-profile")}
            </Link>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
